import "core-js/modules/es.array.reverse";
import "core-js/modules/es.array.slice";
import "core-js/modules/esnext.reflect.metadata";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

import { IsEnum, IsString, IsOptional, IsNumber, IsBoolean } from 'class-validator';
import { ToNumber, ToBoolean } from '@oh-auth/common';
import { ResponseType } from '../../enums';
export var AuthorizeQuery = (_dec = IsEnum(ResponseType), _dec2 = Reflect.metadata("design:type", typeof ResponseType === "undefined" ? Object : ResponseType), _dec3 = IsString(), _dec4 = Reflect.metadata("design:type", String), _dec5 = IsString(), _dec6 = Reflect.metadata("design:type", String), _dec7 = IsOptional(), _dec8 = IsString(), _dec9 = Reflect.metadata("design:type", String), _dec10 = IsOptional(), _dec11 = IsString(), _dec12 = Reflect.metadata("design:type", String), _dec13 = IsOptional(), _dec14 = IsString(), _dec15 = Reflect.metadata("design:type", String), _dec16 = IsOptional(), _dec17 = IsString(), _dec18 = Reflect.metadata("design:type", String), _dec19 = IsOptional(), _dec20 = IsNumber(), _dec21 = ToNumber(), _dec22 = Reflect.metadata("design:type", Number), _dec23 = IsOptional(), _dec24 = IsBoolean(), _dec25 = ToBoolean(), _dec26 = Reflect.metadata("design:type", Boolean), _dec27 = IsOptional(), _dec28 = IsString(), _dec29 = Reflect.metadata("design:type", String), _dec30 = IsOptional(), _dec31 = IsString(), _dec32 = Reflect.metadata("design:type", String), (_class = (_temp = class AuthorizeQuery {
  constructor() {
    _initializerDefineProperty(this, "response_type", _descriptor, this);

    _initializerDefineProperty(this, "client_id", _descriptor2, this);

    _initializerDefineProperty(this, "redirect_uri", _descriptor3, this);

    _initializerDefineProperty(this, "provider_id", _descriptor4, this);

    _initializerDefineProperty(this, "scope", _descriptor5, this);

    _initializerDefineProperty(this, "approval_challenge", _descriptor6, this);

    _initializerDefineProperty(this, "approval_verifier", _descriptor7, this);

    _initializerDefineProperty(this, "approval_verifier_expired_at", _descriptor8, this);

    _initializerDefineProperty(this, "consented", _descriptor9, this);

    _initializerDefineProperty(this, "state", _descriptor10, this);

    _initializerDefineProperty(this, "nonce", _descriptor11, this);
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "response_type", [_dec, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "client_id", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "redirect_uri", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "provider_id", [_dec7, _dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "scope", [_dec10, _dec11, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "approval_challenge", [_dec13, _dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "approval_verifier", [_dec16, _dec17, _dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "approval_verifier_expired_at", [_dec19, _dec20, _dec21, _dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "consented", [_dec23, _dec24, _dec25, _dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec27, _dec28, _dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "nonce", [_dec30, _dec31, _dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));